import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sparkles, ArrowRight } from "lucide-react";
import { WhyComparison } from "../components/WhyComparison";
import { Button } from "../components/ui/button";

export default function Why() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8" data-testid="why-page">
      <div className="text-center">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-brand/30 bg-brand/5 px-3 py-1 text-xs font-semibold text-brand">
          <Sparkles className="h-3.5 w-3.5" /> {t("why.badge")}
        </span>
        <h1 className="mt-5 font-heading text-4xl font-bold tracking-tight sm:text-5xl">{t("why.title")}</h1>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">{t("why.subtitle")}</p>
      </div>

      <div className="mt-10">
        <WhyComparison />
      </div>

      <div className="mt-12 flex justify-center">
        <Button size="lg" className="rounded-full bg-brand text-white hover:bg-brand/90" onClick={() => navigate("/auth")} data-testid="why-cta">
          {t("why.cta")} <ArrowRight className="ml-1.5 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
